export function formatTransactionId(id: string | null | undefined) {
  if (!id) return "-";
  return `#${id.slice(-10).toUpperCase()}`;
}
